function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarsi = function SvgStarsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M6.85 9.732c-.096.358-.604.358-.7 0l-.557-2.069a.36.36 0 0 0-.256-.256L3.268 6.85c-.358-.096-.358-.604 0-.7l2.069-.557a.36.36 0 0 0 .256-.256l.557-2.069c.096-.358.604-.358.7 0l.557 2.069a.36.36 0 0 0 .256.256l2.069.557c.358.096.358.604 0 .7l-2.069.557a.36.36 0 0 0-.256.256zm6.1-1.31c.151-.562.949-.562 1.1 0l.875 3.251a.57.57 0 0 0 .402.402l3.251.875c.562.151.562.949 0 1.1l-3.251.875a.57.57 0 0 0-.402.402l-.875 3.251c-.151.562-.949.562-1.1 0l-.875-3.251a.57.57 0 0 0-.402-.402l-3.251-.875c-.562-.151-.562-.949 0-1.1l3.251-.875a.57.57 0 0 0 .402-.402z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarsi);
export default ForwardRef;